
export const POST_LOGIN_REDIRECT_QUERY_PARAM = 'return';
